/**
 * Additional services are stored in Mongo with Spanish display names.
 * Map known catalog names to i18n keys so EN (and other) locales show the right label.
 */
const SPANISH_NAME_TO_I18N_KEY = {
  'Limpieza Interior': 'interior_cleaning',
  'Limpieza Exterior': 'exterior_cleaning',
  'Inspección ITV': 'itv_inspection',
  // Allow both catalog variants for this extra so EN invoices don't leak Spanish
  'Paradas Técnicas (Pit Stop)': 'extra_pit_stop_technical',
  'Paradas Técnicas': 'extra_pit_stop_technical',
  'Representación': 'representacion',
  'Recuperación (Europa Continental y UK)': 'extra_recovery_continental_uk',
  'Recuperación (Islas Europeas)': 'extra_recovery_islands',
  'Recuperación (Ceuta y Melilla)': 'extra_recovery_ceuta_melilla',
};

/** Long descriptions for catalog rows (Mongo often stores Spanish). */
const SPANISH_NAME_TO_DESC_I18N_KEY = {
  'Limpieza Interior': 'additional_service_desc_interior_cleaning',
  'Limpieza Exterior': 'additional_service_desc_exterior_cleaning',
  'Inspección ITV': 'additional_service_desc_itv_inspection',
  'Paradas Técnicas (Pit Stop)': 'additional_service_desc_pit_stop_technical',
  'Paradas Técnicas': 'additional_service_desc_pit_stop_technical',
  'Representación': 'additional_service_desc_representation',
  'Recuperación (Europa Continental y UK)': 'additional_service_desc_recovery_continental_uk',
  'Recuperación (Islas Europeas)': 'additional_service_desc_recovery_islands',
  'Recuperación (Ceuta y Melilla)': 'additional_service_desc_recovery_ceuta_melilla',
};

/**
 * @param {string} [name]
 * @param {import('i18next').TFunction} t
 * @returns {string}
 */
export function translateAdditionalServiceName(name, t) {
  if (!name || typeof name !== 'string') return name || '';
  const key = SPANISH_NAME_TO_I18N_KEY[name];
  if (!key) return name;
  const translated = t(key);
  return translated === key ? name : translated;
}

/**
 * @param {string} [name] — catalog name from API (typically Spanish)
 * @param {string} [fallbackDescription] — stored description if no catalog key
 * @param {import('i18next').TFunction} t
 * @returns {string}
 */
export function translateAdditionalServiceDescription(name, fallbackDescription, t) {
  if (!name || typeof name !== 'string') return fallbackDescription || '';
  const key = SPANISH_NAME_TO_DESC_I18N_KEY[name];
  if (!key) return fallbackDescription || '';
  const translated = t(key);
  if (!translated || translated === key) return fallbackDescription || '';
  return translated;
}

/** Labels from driver extra categories / admin charge types (ES/EN mixed from API) */
const DRIVER_EXTRA_NAME_TO_I18N_KEY = {
  'Pit Stop': 'admin_charge_pit_stop',
  Espera: 'admin_charge_espera',
  ITV: 'admin_charge_itv',
  Express: 'admin_charge_express',
  'Recogida Extra': 'admin_charge_recogida_extra',
  'Cambio de Ruta': 'admin_charge_cambio_ruta',
  Otros: 'admin_charge_otros',
  'Paradas Técnicas (Pit Stop)': 'extra_pit_stop_technical',
  'Paradas Técnicas': 'extra_pit_stop_technical',
};

/**
 * @param {string} [name]
 * @param {import('i18next').TFunction} t
 * @returns {string}
 */
export function translateDriverExtraCategoryName(name, t) {
  if (!name || typeof name !== 'string') return name || '';
  const key = DRIVER_EXTRA_NAME_TO_I18N_KEY[name];
  if (!key) return name;
  const translated = t(key);
  return translated === key ? name : translated;
}
